"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const native_1 = require("@react-navigation/native");
const moment_1 = __importDefault(require("moment"));
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const react_native_safe_area_context_1 = require("react-native-safe-area-context");
const react_redux_1 = require("react-redux");
const Colors_1 = __importDefault(require("../../../assets/colors/Colors"));
const BackHeader_1 = __importDefault(require("../../../assets/icons/BackHeader"));
const IconComment_1 = __importDefault(require("../../../assets/icons/IconComment"));
const IconLike_1 = __importDefault(require("../../../assets/icons/IconLike"));
const Threedoc_1 = __importDefault(require("../../../assets/icons/Threedoc"));
const images_1 = require("../../../assets/images");
const components_1 = require("../../../components");
const CustomText_1 = __importDefault(require("../../../components/text/CustomText"));
const constants_1 = require("../../../constants");
const rootNavigation_1 = require("../../../navigators/rootNavigation");
const Routes_1 = __importDefault(require("../../../navigators/Routes"));
const scale_1 = require("../../../utils/scale");
const styles_1 = __importDefault(require("./styles"));
const CreateArticlePreview = () => {
    const navigation = (0, native_1.useNavigation)();
    const inset = (0, react_native_safe_area_context_1.useSafeAreaInsets)();
    const articleCreating = (0, react_redux_1.useSelector)((state) => state.articleCreatingReducer);
    const myProfile = (0, react_redux_1.useSelector)((state) => state.loginReducer.dataProfile);
    (0, react_1.useEffect)(() => {
        if (!articleCreating.content_type) {
            navigation.reset({ index: 0, routes: [{ name: Routes_1.default.MAINTABBAR }] });
        }
    }, [articleCreating]);
    (0, react_1.useEffect)(() => {
        const handleBeforeUnload = (event) => {
            const message = 'Are you sure you want to leave?';
            event.returnValue = message;
            return message;
        };
        window.addEventListener('beforeunload', handleBeforeUnload);
        return () => {
            window.removeEventListener('beforeunload', handleBeforeUnload);
        };
    }, []);
    return (react_1.default.createElement(react_native_1.View, { style: styles_1.default.container },
        react_1.default.createElement(components_1.Header, { statusBarStyle: "dark-content", styleViewCenter: { alignItems: "center" }, title: "表示プレビュー", styleContainer: {
                backgroundColor: Colors_1.default.white,
            }, leftIcon: react_1.default.createElement(BackHeader_1.default, { color: "#21242D" }), onLeftPress: rootNavigation_1.goBack }),
        react_1.default.createElement(react_native_1.ScrollView, { style: { flex: 1 }, contentContainerStyle: { paddingBottom: inset.bottom + (0, scale_1.scale)(24) }, showsVerticalScrollIndicator: false },
            react_1.default.createElement(react_native_1.Image, { source: !!articleCreating.thumbnail_image ?
                    { uri: articleCreating.thumbnail_image }
                    :
                        images_1.images.NoImages, style: styles_1.default.backgroundImage }),
            react_1.default.createElement(react_native_1.View, { style: [styles_1.default.editContainer, { paddingBottom: inset.bottom }] },
                react_1.default.createElement(CustomText_1.default, { weight: "600", style: styles_1.default.title }, articleCreating.title),
                react_1.default.createElement(react_native_1.View, { pointerEvents: 'none' },
                    react_1.default.createElement(react_native_1.View, { style: { flexDirection: 'row', flexWrap: 'wrap', marginTop: (0, scale_1.scale)(8), gap: (0, scale_1.scale)(8) } }, articleCreating?.hashtags.map((item, index) => (react_1.default.createElement(CustomText_1.default, { style: styles_1.default.hashtagItem, key: index },
                        "#",
                        item))))),
                react_1.default.createElement(react_native_1.View, { style: styles_1.default.author },
                    react_1.default.createElement(react_native_1.Image, { source: myProfile?.thumbnail_url ?
                            { uri: myProfile?.thumbnail_url }
                            :
                                images_1.images.AvatarDefaul, style: styles_1.default.avatar }),
                    react_1.default.createElement(react_native_1.View, { style: styles_1.default.userInfo },
                        react_1.default.createElement(CustomText_1.default, { weight: '600', style: styles_1.default.userNickname }, myProfile?.nickname || constants_1.DEFAULT_NAME),
                        react_1.default.createElement(CustomText_1.default, { style: styles_1.default.userHandle }, (0, moment_1.default)().format('YYYY/MM/DD')))),
                react_1.default.createElement(react_native_1.View, { style: styles_1.default.articleStatus },
                    react_1.default.createElement(react_native_1.View, { style: styles_1.default.articleStatusLeft },
                        react_1.default.createElement(react_native_1.View, null,
                            react_1.default.createElement(CustomText_1.default, { weight: "600", style: styles_1.default.statusNumber },
                                "0",
                                react_1.default.createElement(CustomText_1.default, { weight: "300", style: styles_1.default.statusUnit }, "\u4EF6\u306E\u30B3\u30E1\u30F3\u30C8"))),
                        react_1.default.createElement(CustomText_1.default, { weight: "600", style: styles_1.default.statusNumber },
                            "0",
                            react_1.default.createElement(CustomText_1.default, { weight: "300", style: styles_1.default.statusUnit }, "\u4EF6\u306E\u3044\u3044\u306D"))),
                    react_1.default.createElement(react_native_1.View, { style: { transform: [{ rotate: '90deg' }] } },
                        react_1.default.createElement(Threedoc_1.default, null))),
                react_1.default.createElement(react_native_1.View, { style: styles_1.default.statusRow },
                    react_1.default.createElement(react_native_1.View, { style: styles_1.default.commentButton },
                        react_1.default.createElement(IconComment_1.default, { width: (0, scale_1.scale)(28), height: (0, scale_1.scale)(28), color: '#545454' })),
                    react_1.default.createElement(react_native_1.View, null,
                        react_1.default.createElement(IconLike_1.default, { width: (0, scale_1.scale)(28), height: (0, scale_1.scale)(28), color: '#545454' }))),
                react_1.default.createElement(react_native_1.View, { style: styles_1.default.editView, pointerEvents: 'none' },
                    react_1.default.createElement("style", null, `
                .editView p {
                  margin: 0;
                  padding: 0;
                }
                .ql-editor {
                  padding: 0px 0px;
                  margin-bottom: 0px;
                }
						  `),
                    react_1.default.createElement("div", { className: "ql-snow" },
                        react_1.default.createElement("div", { className: "ql-editor editView", dangerouslySetInnerHTML: { __html: articleCreating?.full_text || '' } }))),
                !!articleCreating.inherited_from_user_id && (react_1.default.createElement(react_native_1.View, { style: styles_1.default.inheritView },
                    react_1.default.createElement(CustomText_1.default, { weight: '600', style: styles_1.default.inheritUserLabel },
                        "\u7D99\u627F\u5143\u306E",
                        articleCreating.content_type == 1 ? '記事' : '自分史',
                        "\u3092\u4F5C\u6210\u3057\u305F\u5148\u8F29"),
                    react_1.default.createElement(react_native_1.View, { style: styles_1.default.author },
                        react_1.default.createElement(react_native_1.Image, { source: articleCreating.inherited_from_user_thumbnail ?
                                { uri: articleCreating.inherited_from_user_thumbnail }
                                :
                                    images_1.images.AvatarDefaul, style: styles_1.default.avatar }),
                        react_1.default.createElement(react_native_1.View, { style: styles_1.default.userInfo },
                            react_1.default.createElement(CustomText_1.default, { weight: '600', style: styles_1.default.userNickname }, articleCreating.inherited_from_user_nickname || constants_1.DEFAULT_NAME),
                            react_1.default.createElement(CustomText_1.default, { style: styles_1.default.userHandle },
                                "@",
                                articleCreating.inherited_from_user_handle)))))))));
};
exports.default = CreateArticlePreview;
